<template>
  <div>
    <router-view v-bind:is="layout"></router-view>
    <logout-refresh-modal />
  </div>
</template>

<script>
import PageLayout from "./views/Layout/PageLayout";
import SimpleLayout from "./views/Layout/SimpleLayout";
import { logoutRefreshMixin } from "@/components/mixins/logout-refresh.mixin";
import { LogoutRefreshModal } from "./components";
import CheckoutLayout from "./views/Layout/CheckoutLayout.vue";

export default {
  name: "App",
  data() {
    return {
      modals: {
        logoutRefreshModal: false,
      },
    };
  },
  mixins: [logoutRefreshMixin],
  computed: {
    layout() {
      return this.$store.getters.layout;
    },
  },
  mounted() {
    // Check app version
    if (
      window.location.host === "artgrab.co" ||
      window.location.host === "www.artgrab.co" ||
      window.location.host === "dev-web.artgrab.co"
    ) {
      this.initVersionCheck("/version.json");
    }
  },
  components: {
    "page-layout": PageLayout,
    "simple-layout": SimpleLayout,
    "checkout-layout": CheckoutLayout,
    LogoutRefreshModal,
  },
  watch: {
    hashChanged(val) {
      if (val) {
        this.modals.logoutRefreshModal = true;
      }
    },
  },
};
</script>
